/**
 * Mek Records logo for light backgrounds: the yellow bars (the mark) beside the lettering in ink.
 * Owner's rule: never the yellow lettering on a black tile. `large` stacks the two for the login screen.
 */
export function Brand({ large = false }: { large?: boolean }) {
  return (
    <span className={`brand${large ? ' large' : ''}`} role="img" aria-label="Mek Records">
      <img className="brand-mark" src="/brand/mek-records-mark.svg" alt="" width={large ? 74 : 30} height={large ? 60 : 25} />
      <img className="brand-word" src="/brand/mek-records-wordmark-ink.svg" alt="" width={large ? 160 : 82} height={large ? 56 : 29} />
    </span>
  );
}
